import { Alert, TextLink } from '@palmetto/palmetto-components';

export const MountingTypeAlert = () => (
  <Alert
    variant="info"
    message={
      <>
        Palmetto requires all systems be Roof Mounted with Attachments and Racking components from Approved Vendors.
        For more information,{' '}
        <TextLink
          href="https://help.palmetto.finance/en/articles/8708580-eligible-sites"
          target="_blank"
          rel="noopener noreferrer"
        >
          check the Knowledge Base
        </TextLink>
        .
      </>
    }
  />
);
